import React from 'react';

export type ReactFCC<T = unknown> = React.FC<T & { children?: React.ReactNode }>;
export type ReactFCV<T = unknown> = React.VFC<T>;

export enum EPage {
  HOME_PAGE = 'HOME_PAGE',
  CART = 'CART',
  UPSELLING = 'UPSELLING',
  DELIVERY_AND_PAYMENT = 'DELIVERY_AND_PAYMENT',
  RESERVATION = 'RESERVATION',
  CART_LOG_IN = 'CART_LOG_IN',
  PAYMENT_AND_DELIVERY = 'PAYMENT_AND_DELIVERY',
  THANK_YOU = 'THANK_YOU',
  SUMMARY = 'SUMMARY',
  REPAY = 'REPAY',
  RESERVATION_PAYMENT_AND_DELIVERY = 'RESERVATION_PAYMENT_AND_DELIVERY',
  LOGIN_PAGE = 'LOGIN_PAGE',
  BENEFITS_PAGE = 'BENEFITS_PAGE',
  DISCOVERY_BOX = 'DISCOVERY_BOX',
  REGISTER_PAGE = 'REGISTER_PAGE',
  ADYEN_PAYMENT_REDIRECT_PAGE = 'ADYEN_PAYMENT_REDIRECT_PAGE',
  GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE = 'GLOBAL_PAYMENTS_PAYMENT_REDIRECT_PAGE',
  GOPAY_PAYMENT_REDIRECT_PAGE = 'GOPAY_PAYMENT_REDIRECT_PAGE',
  LOYALTY_PROGRAM = 'LOYALTY_PROGRAM',
  PRZELEWY_PAYMENT_REDIRECT_PAGE = 'PRZELEWY_PAYMENT_REDIRECT_PAGE',
}

declare global {
  interface Window {
    bvCallback: TBazaarvoiceIntegration;
  }
}
